import React, { useEffect } from 'react';
import { useNavigate as useReactRouterNavigate } from 'react-router-dom';

// Create a global navigate function that can be used outside of React components
let globalNavigate = null;

export const setGlobalNavigate = (navigate) => {
  globalNavigate = navigate;
};

export const navigate = (path, options = {}) => {
  if (globalNavigate) {
    globalNavigate(path, options);
  } else {
    // Fallback to window.location if navigate is not available
    console.warn('Navigate function not initialized, using window.location fallback');
    if (path?.startsWith('/')) {
      window.location.href = path;
    } else {
      console.error('Invalid path for navigation:', path);
    }
  }
};

// Hook for use within React components
export const useNavigate = () => {
  return useReactRouterNavigate();
};

// Simple hook to initialize navigation - to be used in a component inside BrowserRouter
export const useNavigationInit = () => {
  const navigate = useReactRouterNavigate();
  
  React.useEffect(() => {
    setGlobalNavigate(navigate);
    return () => {
      globalNavigate = null;
    };
  }, [navigate]);
};